export default __webpack_public_path__ + "static/airbubbles-3703e03d76ee76f92ac7f1724ec75edd.png";